import React, { useEffect, useState, useRef } from "react";
import Product from "./Product";
import { useSelector, useDispatch } from "react-redux";
import { getProducts } from "../../reducers";
import { useWindowSize } from "../../hooks";
import "./Products.style.css";
import ScrollIndecator from "./ScrollIndicator/ScrollIndicator";

const Products = ({ orderType }) => {
  const windowSize = useWindowSize();

  const dispatch = useDispatch();
  const products = useSelector((state) => state.products);

  const [selectedCategory, setSelectedCategory] = useState("bodyCare");
  const productsRef = useRef();

  const Categories = {
    bodyCare: "Body Care",
    environment: "Environment",
    grocery: "Grocery",
    health: "Health",
  };

  const grocery = {
    "grocery-cereals": "Cereals",
    "grocery-ghee": "Ghee",
    "grocery-honeyJaggery": "Honey Jaggery",
    "grocery-masala": "Masala",
    "grocery-misc": "Misc",
    "grocery-oils": "Oils",
    "grocery-pulses": "Pulses",
  };

  useEffect(() => {
    dispatch(getProducts(selectedCategory));
  }, [selectedCategory]);

  return (
    <div className="mb-4">
      <div className="d-flex filter-products mb-2 scrollbar-hide products-link-wrapper">
        <ul className="scrollbar-hide d-flex products-link">
          {Object.entries(Categories).map(([key, value], index) => (
            <li
              key={index}
              className={`btn filter-button ${
                selectedCategory?.split("-")[0] === key ? "active" : ""
              }`}
              onClick={() =>
                setSelectedCategory((prev) => {
                  if (key !== prev) {
                    return key !== "grocery" ? key : "grocery-cereals";
                  }
                })
              }
            >
              {value}
            </li>
          ))}
        </ul>
      </div>
      {selectedCategory?.split("-")[0] === "grocery" ? (
        <div className="d-flex justify-content-center align-items-center grocery-items">
          <ul id="grocery-filters" className="scrollbar-hide">
            {Object.entries(grocery).map(([key, value], index) => (
              <li
                key={index}
                className={`filter-grocery ${
                  selectedCategory === key ? "active" : ""
                }`}
                onClick={() => setSelectedCategory(key)}
                data-filter="grocery-cereals"
                id="grocery1"
              >
                {value.toUpperCase()}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        ""
      )}

      <p className=" mb-3 products-link products-para">
        Note: Lorem ipsum dolor sit amet consectetur adipisicing elit. Fugiat,
        consequatur.
      </p>

      <div className="">
        <div
          ref={productsRef}
          className="row mx-0 productsSectionContainer justify-content-center align-items-center scrollbar-hide"
        >
          {products.map((product) => (
            <Product data={product} key={product.id} orderType={orderType} />
          ))}
        </div>
      </div>
      <ScrollIndecator
        targetRef={productsRef}
        count={
          Math.ceil(products.length / 2) - (windowSize.width <= 600 ? 1 : 2)
        }
        offset={windowSize.width / (windowSize.width <= 600 ? 2 : 3)}
      />
    </div>
  );
};

export default Products;
